/* tslint:disable:max-line-length */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  step1: {
    defaultMessage: 'You will be securely transferred to {providerName}.',
    id: 'AwaitingThirdpartyAuthentication.step1',
  },
  securityCaption: {
    defaultMessage: 'Your bank login details are only visible to you',
    id: 'AwaitingThirdpartyAuthentication.securityCaption',
  },
});
